import { Users, ArrowUpDown, Clock, ShieldCheck, Cloud } from "lucide-react";

const stats = [
  { icon: Users, label: "500+ usu\u00e1rios", description: "confiam no Next AI Finance" },
  { icon: ArrowUpDown, label: "50.000+ transa\u00e7\u00f5es", description: "registradas na plataforma" },
  { icon: Clock, label: "99.9% uptime", description: "disponibilidade garantida" },
];

const badges = [
  { icon: ShieldCheck, label: "Dados criptografados" },
  { icon: Cloud, label: "Supabase Cloud" },
];

export function SocialProofBar() {
  return (
    <section className="border-y bg-muted/30">
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          {/* Stats */}
          <div className="flex flex-wrap justify-center gap-8 lg:gap-12">
            {stats.map((stat) => (
              <div key={stat.label} className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
                  <stat.icon className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="font-semibold text-foreground text-sm">{stat.label}</p>
                  <p className="text-xs text-muted-foreground">{stat.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className="hidden lg:block h-10 w-px bg-border" />

          {/* Security badges */}
          <div className="flex items-center gap-6">
            {badges.map((badge) => (
              <div key={badge.label} className="flex items-center gap-2 text-muted-foreground">
                <badge.icon className="h-4 w-4" />
                <span className="text-xs font-medium">{badge.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
